import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux" //Token
import { STATUS_LOAN } from "../Components/Colaboradores/Solicitudes/constants"
import { PERFILES } from "../Constants/Strings"
import { getPrestamosStatus } from "../Services/Api_prestamos"
//Componentes
import PrestamosTabla from "../Components/Colaboradores/Solicitudes/prestamos_componentes/PrestamosTabla"
//Material UI
import useHasPermission from "#hooks/useHasPermission"
import Grid from "@mui/material/Unstable_Grid2"
import { ChangeTitle } from "Components/menu/funciones"
import { InputSelectGrid2 } from "../Components/Common/Inputs2"
import { SkeletonSquareGrid } from "../Components/Common/Skeleton"
import PrestamosFila from "./../Components/Colaboradores/Solicitudes/prestamos_componentes/PrestamosFila"
import { LoanTable } from "#loan/components/table/LoanTable"

function PrestamosSolicitudes() {
	const { hasPermissionV2, getTopPermission } = useHasPermission()
	const dispatch = useDispatch()
	const token = useSelector((state) => state.user.token)
	const [status, setStatus] = useState(STATUS_LOAN["PROCESS"])
	const [dbStatus, setDBStatus] = useState([])
	const [skeleton1, setSkeleton1] = useState(false)
	const [actualizar, setActualizar] = useState(true)
	const PERMISOS = {
		[PERFILES["ADMIN"]]: {
			user: PERFILES["ADMIN"],
			status: status,
		},
		[PERFILES["RH"]]: {
			user: PERFILES["RH"],
			status: status,
		},
		[PERFILES["GERENTE"]]: {
			user: PERFILES["GERENTE"],
			status: STATUS_LOAN["VALIDATE_RH"],
		},
		[PERFILES["PAGOS"]]: {
			user: PERFILES["PAGOS"],
			status: STATUS_LOAN["PAY"],
		},
		[PERFILES["COLABORADOR"]]: {
			user: "Colaborador",
			status: STATUS_LOAN["AWAITED_DOCUMENT"],
		},
	}

	let puesto = useSelector((state) => state.user.profiles)
	let permiso = PERMISOS["Colaborador"]
	let filtroApi = { status: permiso["status"] }
	let selectShow = hasPermissionV2([PERFILES.RH])
	const rowShow = hasPermissionV2([PERFILES.RH, PERFILES.PAGOS])

	ChangeTitle("Préstamo")
	useEffect(() => {
		getPrestamosStatus(token, setDBStatus, {}, setSkeleton1)
	}, [dispatch, token])

	puesto = getTopPermission([
		PERFILES["ADMIN"],
		PERFILES["RH"],
		PERFILES["PAGOS"],
		PERFILES["GERENTE"],
		PERFILES["COLABORADOR"],
	])

	permiso = PERMISOS[puesto]
	if (!permiso) permiso = PERMISOS["Colaborador"]

	filtroApi["status"] = permiso["status"]

	if (!permiso) permiso = { user: 0, status: 404 }

	if (permiso["user"] === PERFILES.GERENTE) filtroApi["jefe"] = ""
	useEffect(() => {
		if (hasPermissionV2([PERFILES.PAGOS], true)) setStatus(STATUS_LOAN.PAY)
		else if (!selectShow) setStatus(STATUS_LOAN.VALIDATE_RH)
	}, [permiso, selectShow])

	return (
		<React.Fragment>
			{!skeleton1 && <SkeletonSquareGrid />}

			{skeleton1 && (
				<Grid
					container
					columnSpacing={3}
					rowSpacing={1}
					justifyContent={"center"}
					alignItems={"center"}
				>
					{selectShow && (
						<InputSelectGrid2
							label="Estado"
							data={dbStatus}
							dataLabel="descripcion"
							dataID="id"
							value={status}
							setValue={setStatus}
							all="TODO"
						/>
					)}
					{rowShow && (
						<Grid>
							<PrestamosFila show={false} actualizar={actualizar} />
						</Grid>
					)}
					<LoanTable status={status} permiso={permiso} />
					{/* <PrestamosTabla
						showFila={true}
						filtro={filtroApi}
						permiso={permiso}
						actualizar={actualizar}
						setActualizar={setActualizar}
						size={12}
					/> */}
				</Grid>
			)}
		</React.Fragment>
	)
}

export default PrestamosSolicitudes
